import type { CaptchaAnswer, CaptchaChallenge, CaptchaTracePoint } from '../../types';

export interface CaptchaViewProps {
  challenge: CaptchaChallenge;
  /** Time origin for trace timestamps (when the challenge was shown) */
  startedAt: number;
  disabled: boolean;
  onSubmit: (answer: CaptchaAnswer) => void;
}

export const pngSrc = (base64: string) => `data:image/png;base64,${base64}`;

/** Pointer position converted from screen pixels to image pixels. */
export function toImagePoint(
  event: { clientX: number; clientY: number; timeStamp?: number },
  element: HTMLElement,
  imageWidth: number,
  startedAt: number
): CaptchaTracePoint {
  const rect = element.getBoundingClientRect();
  const scale = rect.width > 0 ? imageWidth / rect.width : 1;
  // The event's own timestamp (same clock as performance.now()) records when the input
  // happened, even if a busy page handles several events together.
  const time = event.timeStamp && event.timeStamp > 0 ? event.timeStamp : performance.now();
  return {
    t: Math.round(time - startedAt),
    x: (event.clientX - rect.left) * scale,
    y: (event.clientY - rect.top) * scale,
  };
}
